import React from 'react';

import AboutUs from './AboutUs';
// import Testinomial from './About/testinomial';
import Footer from '../footer/footer';

function AboutUsPage() {
  return (
    <div>
        
        <AboutUs/>
       {/* <Testinomial/> */}
        <Footer/>
    </div>
  )
}

export default AboutUsPage